const ACTIVITIES_FORM_KEYS = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  objective: 'objective',
  difficulty: 'difficulty',
  materials: 'materials',
  time: 'time',
  language: 'language',

  //for american activity
  curriculumFramework: 'curriculumFramework',
  specificStandards: 'specificStandards',
  strategies: 'strategies',
};

export default ACTIVITIES_FORM_KEYS;
